import { CurrencyPipe, Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewChild, viewChild } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState, selectCurrencyInCommonState, selectLanguageInCommonState } from 'app/app-state.index';
import { WebRouletteSubscription } from 'app/public/model/web-roulette-subscription.model';
import { StripePaymentsService } from 'app/public/services/stripe-payments.service';
import { SubscriptionService } from 'app/public/services/subscription.service';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { CurrencyType, Language, PaymentType } from 'app/shared/model/enums';
import { AdvMessageService } from 'app/shared/services/message.service';
import { Observable, Subscriber, Subscription } from 'rxjs';
import { StripeService } from 'ngx-stripe';
import { CommonService } from 'app/shared/services/common.service';
import { AppAuthService } from 'app/shared/services/app-auth.service';
import { AnalyticsService } from 'app/public/services/analytics.service';


@Component({
  selector: 'app-roulette-subscribtion',
  templateUrl: './roulette-subscribtion.component.html',
  styleUrls: ['./roulette-subscribtion.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RouletteSubscribtionComponent implements OnInit {
  @ViewChild('tabs') tabs:any;
  activateIndex :number;
  rouletteId: any;
  rouletteWebSubscriptions: WebRouletteSubscription[];
  rouletteFrontalSubscriptions: WebRouletteSubscription[];
  currency: CurrencyType;
  subscriptions = new Subscriber();
  curencyEnum = CurrencyType;
  paymentType = PaymentType;
  returnUrl: string
  colors = ['red', 'blue', 'green', 'yellow'];

  @Input()
  IsViewMode: boolean;

  constructor(private commonService: CommonService, private route: ActivatedRoute, private subscribtionService: SubscriptionService
    ,private store: Store<AppState>,
    private analytctis:AnalyticsService,
     private cdr: ChangeDetectorRef, private router: Router, private messageService: AdvMessageService, private location: Location
    , private stripePaymentsService: StripePaymentsService, private stripeService: StripeService, private localizationService: LocalizationService, 
    private AppAuthService: AppAuthService) {
    this.subscriptions.add(store.select(selectCurrencyInCommonState).subscribe(currency => {
      this.currency = currency;
    }));
    this.subscriptions.add(this.route.url.subscribe(urlsubscriber => {
      this.rouletteId = this.route.snapshot.params["rouletteId"];
      this.returnUrl = this.route.snapshot.params['returnUrl'];
      this.IsViewMode = this.IsViewMode || (this.route.snapshot.queryParams['viewMode'] ? true : false);
    }));
   
  }

  ngOnInit(): void {
    if (!this.IsViewMode) {
      this.commonService.changeCurrentPageHeader(this.localizationService.Translate('SUBSCRIPTION.TITLE'));
    }
    this.subscriptions.add(this.store.select(selectLanguageInCommonState).subscribe(language => {
      this.loadSubscriptions(language);
    }));
  }

  loadSubscriptions(language: Language) {
    let getSubscription;
    if (this.IsViewMode || !this.rouletteId) {
      getSubscription = this.subscribtionService.getAllSubscriptions(this.currency, language);
    } else {
      getSubscription = this.subscribtionService.getSubscriptions(this.rouletteId, this.currency, language);
    }
    getSubscription.subscribe(subscribtions => { 
      this.rouletteWebSubscriptions =subscribtions.filter(s=>s.PackageType != 3).sort((first, second) => { return first.Price - second.Price });
      this.rouletteFrontalSubscriptions =subscribtions.filter(s=>s.PackageType == 3).sort((first, second) => { return first.Price - second.Price });
      [this.rouletteFrontalSubscriptions ,this.rouletteWebSubscriptions].forEach(arr => {
        let startWithIndex = arr.length === 4 ? 0 : 1;
        let index=startWithIndex;
        arr.forEach(subscription => {
        subscription = Object.assign(
          subscription,
          {
            color: this.colors[index===this.colors.length?index=startWithIndex:index++]
          }
        )
      });
      });
      const sizeKeys = ['SMALL', 'MEDIUM', 'LARGE'];

      [this.rouletteFrontalSubscriptions, this.rouletteWebSubscriptions].forEach(arr => {
        const hasCampaignFirst = arr.length > 0 && arr[0].IsAllowToSendCampain;
        let regularIndex = 0;
        arr.forEach((subscription, index) => {
          if (index === 0 && hasCampaignFirst) {
            subscription.customersDatabase = sizeKeys[1];
          } else {
            subscription.customersDatabase = sizeKeys[regularIndex % sizeKeys.length];
            regularIndex++;
          }
        });
    });
    
    // When upgrading a specific roulette (not in view mode), set the active tab based on which packages are available
    // This ensures frontal roulettes show only frontal packages and web roulettes show only web packages
    if (!this.IsViewMode && this.rouletteId) {
      if (this.rouletteFrontalSubscriptions.length > 0 && this.rouletteWebSubscriptions.length === 0) {
        this.activateIndex = 1; // Show frontal tab
      } else if (this.rouletteWebSubscriptions.length > 0 && this.rouletteFrontalSubscriptions.length === 0) {
        this.activateIndex = 0; // Show web tab
      }
    } else {
      this.activateIndex = 0;
    }
      this.cdr.markForCheck();   
       
    })
  }

 
  selectSubscription(subscribtion: WebRouletteSubscription): Observable<any> {
  let paymentType=1
 
   if(subscribtion.IsYearlyPackage)
    paymentType=4
   else if(subscribtion.AutoRenewalPackage)
    paymentType=2
    if (!this.rouletteId)
      this.router.navigate(['roulette']);
    if (this.IsViewMode) {
      return;
    }

    this.commonService.blockScreen(true);
    if (subscribtion.IsFreePackage) {
      this.subscribtionService.buyFreeSubscription(this.rouletteId, subscribtion.PackageId).subscribe(response => {
        this.commonService.blockScreen(false);
        this.messageService.successMessage("SUBSCRIPTION.SUCCESS_BUY_FREE", true);
        this.router.navigate(['webplatform', 'my-roulettes'])
      })
      return;
    }
    this.subscribtionService.getMockPaymentStatus().subscribe((response: any) => {
      if (response.MockPaymentStatus) {
        this.subscribtionService.buyTestSubscription({
          rouletteId: this.rouletteId,
          productId: subscribtion.ProductId,
          packageId: subscribtion.PackageId,
          AutoRenwal:subscribtion.AutoRenewalPackage,
          PaymentType: paymentType
        }).subscribe((res: any) => {
          this.analytctis.sendEvent('buy-subscription', {
            packageId: subscribtion.PackageId,
            productId: subscribtion.ProductId,
            email: this.AppAuthService.authEmail,
            paymentType: paymentType,
            rouletteId: this.rouletteId,
          });     
          this.commonService.blockScreen(false);
          this.messageService.successMessage("SUBSCRIPTION.SUCCESS_BUY_TEST", true);
          this.router.navigate(['webplatform', 'my-roulettes'])
        })
      }
      else {
        this.analytctis.sendEvent('buy-subscription', {
          packageId: subscribtion.PackageId,
          productId: subscribtion.ProductId,
          email: this.AppAuthService.authEmail,
          paymentType: paymentType,
          rouletteId: this.rouletteId,
        });       
        this.stripePaymentsService.createSession(subscribtion.PackageId, subscribtion.ProductId, "", ""
          , "/webplatform/payment-success", "/webplatform/payment-failed", this.rouletteId, this.AppAuthService.authEmail,paymentType).subscribe(response => {            
            this.stripeService.redirectToCheckout({
              sessionId: response.SessionId,
            }).subscribe(data => {
              this.commonService.blockScreen(false);
            });
          });
      }
    }
  )
  }
  back(): void {
    if (this.returnUrl) {
      this.router.navigate([this.returnUrl])
    }
    else {
      this.location.back()
    }
  }
  ngOnDestroy() {
    this.commonService.clearCurrentPageHeader();
    this.subscriptions.unsubscribe();
  }

}
